import './header.component.scss'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

class HeaderHarms {
  constructor(elements, config, classes) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.init()
  }

  calcHeight(elem) {
    let res = 0
    const list = Array.from(elem.children)

    list.forEach(item => {
      const height = item.offsetHeight
      const marginTop = window.getComputedStyle(item).marginTop
      res += height
      res += parseInt(marginTop)
    })

    return res
  }

  close(link) {
    const item = link.closest(`.${this.classes.elements.harmItem}`)
    const list = item.querySelector(`.${this.classes.elements.harmList}`)

    const toggleClass = () => {
      item.classList.remove(this.classes.status.opened)
    }

    const toggleTransform = () => {
      // const decreaseParentsHeight = (current, currentHeight) => {
      //   const parentList = current.closest('li')
      //   const parentSub = parentList.closest('ul')

      //   if (!parentSub.classList.contains('nav-list_main')) {
      //     const parentHeight = parseInt(parentSub.style.height)
      //     const newParentHeight = parentHeight - currentHeight
      //     parentSub.style.height = `${newParentHeight}px`

      //     decreaseParentsHeight(parentSub, newParentHeight)
      //   }
      // }
      // const listHeight = parseInt(list.style.height)
      // decreaseParentsHeight(list, listHeight)

      list.removeAttribute('style')
    }
    // const closeChilds = () => {
    //   list.querySelectorAll('li.opened').forEach(item => {
    //     item.classList.remove(this.classes.status.opened)
    //     item.querySelector('ul').removeAttribute('style')
    //   })
    // }

    // closeChilds()
    toggleClass()
    toggleTransform()
  }

  open(link) {
    const parentLi = link.closest(`.${this.classes.elements.harmItem}`)

    const toggleClass = () => {
      const closeOther = () => {
        const parentUl = parentLi.closest('ul')
        const openedLis = parentUl.querySelectorAll(`.${this.classes.status.opened}`)

        openedLis.forEach(item => {
          this.close(item.querySelector(`.${this.classes.elements.harmLink}`))
        })
      }
      closeOther()

      parentLi.classList.add(this.classes.status.opened)
    }
    const toggleTransform = () => {
      const list = parentLi.querySelector(`.${this.classes.elements.harmList}`)
      const height = this.calcHeight(list)
      list.style.height = `${height}px`

      // const calcParentHeight = (current, currentHeight) => {
      //   const parentList = current.closest('li')
      //   const parentSub = parentList.closest('ul')

      //   if (!parentSub.classList.contains('nav-list_main')) {
      //     const parentHeight = parseInt(parentSub.style.height)
      //     const newParentHeight = currentHeight + parentHeight
      //     parentSub.style.height = `${newParentHeight}px`

      //     calcParentHeight(parentSub, newParentHeight)
      //   }
      // }
      // calcParentHeight(list, height)
    }

    toggleClass()
    toggleTransform()
  }

  isOpened(elem) {
    return elem.closest(`.${this.classes.elements.harmItem}`).classList.contains(this.classes.status.opened)
  }

  toggle(event) {
    if (window.innerWidth < this.config.breakpoint) {
      event.preventDefault()

      const link = event.target

      if (this.isOpened(link)) {
        this.close(link)
      } else {
        this.open(link)
      }
    }
  }

  forceClose() {
    const openedItem = this.elements.main.header.querySelector(`.${this.classes.elements.harmItem}.${this.classes.status.opened}`)
    if (openedItem) {
      const openedList = openedItem.querySelector(`.${this.classes.elements.harmList}`)
      openedList.removeAttribute('style')

      openedItem.classList.remove(this.classes.status.opened)
    }
  }

  init() {
    this.elements.harms.items.forEach(item => {
      const link = item.querySelector(`.${this.classes.elements.harmLink}`)
      link.addEventListener('click', this.toggle.bind(this))
    })
  }
}

class HeaderSubs {
  constructor(elements, config, classes, functions) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.scroll = functions.scroll

    this.currentElements = {
      source: null,
      drop: null
    }

    this.init()
  }

  isMobile() {
    return window.innerWidth < this.config.breakpoint
  }

  isOpened() {
    return this.currentElements.source && this.currentElements.drop
  }

  addOpenClasses() {
    this.elements.sub.openedDest.append(this.currentElements.drop)
    this.elements.sub.openedWrap.classList.add(this.classes.status.opened)
    this.elements.main.header.classList.add(this.classes.status.subOpened)
  }

  setCurrents(source, drop) {
    this.currentElements.source = source
    this.currentElements.drop = drop
  }

  moveToSource() {
    this.currentElements.source.append(this.currentElements.drop)
  }

  clearCurrents() {
    this.currentElements.source = null
    this.currentElements.drop = null
  }

  removeOpenClasses() {
    this.elements.sub.openedWrap.classList.remove(this.classes.status.opened)
    this.elements.main.header.classList.remove(this.classes.status.subOpened)
  }

  open(event) {
    if (this.isMobile()) {
      event.preventDefault()

      this.elements.sub.openedDest.scrollTo(0, 0)

      const btn = event.target
      const source = btn.closest(`.${this.classes.elements.dropItem}`)
      const drop = source.querySelector(`.${this.classes.elements.dropList}`)
      this.elements.sub.backBtn.textContent = btn.textContent

      if (drop) {
        this.setCurrents(source, drop)

        this.addOpenClasses()

				this.createItemOverview(btn, source, drop)

        setTimeout(() => {
					this.elements.main.header.style.setProperty('--nav-back-btn-height', `${this.elements.sub.backBtn.offsetHeight}px`)
				}, this.config.animationDuration);

        this.scroll.disable(this.elements.sub.openedDest)
      }
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    if (this.isOpened()) {
      const animateClosing = () => {
        this.elements.sub.openedWrap.classList.add(this.classes.status.closing)
        setTimeout(() => {
          this.elements.sub.openedWrap.classList.remove(this.classes.status.closing)
          this.moveToSource()
          this.clearCurrents()
        }, this.config.animationDuration)
      }

      this.removeOpenClasses()
      // this.elements.main.header.style.removeProperty('--nav-back-btn-height')

			this.removeItemOverview()

      animateClosing()

      this.scroll.enable()
      this.scroll.disable(this.elements.menu.inner)
      // this.elements.sub.backBtn.textContent = ''

      this.harms.forceClose()
    }
  }

	createItemOverview(link, li, targetPlace) {
		if (!li.classList.contains('no-hover')) {
			let newItem = ''

			newItem = `<li class="${this.classes.elements.itemOverview}"><a href="${link.getAttribute('href')}">${link.textContent} Overview</a></li>`

			targetPlace.insertAdjacentHTML('beforeend', newItem)

			newItem = document.querySelector(`.${this.classes.elements.itemOverview}`)

			setTimeout(() => {
				this.elements.main.header.style.setProperty('--item-overview-height', `${newItem.offsetHeight}px`)
			}, this.config.animationDuration);
		}
	}

	removeItemOverview() {
		const newItem = this.currentElements.drop.querySelector(`.${this.classes.elements.itemOverview}`)
		if (newItem) {
			newItem.remove()
		}
	}

  forceClose() {
    if (this.isOpened()) {
      this.moveToSource()
      this.clearCurrents()
      this.removeOpenClasses()
      // this.elements.main.header.style.removeProperty('--nav-back-btn-height')

      this.harms.forceClose()
    }
  }

  defineEvents() {
    this.elements.sub.openBtns.forEach(btn => {
      btn.addEventListener('click', this.open.bind(this))
    })

    this.elements.sub.backBtn.addEventListener('click', this.close.bind(this))
  }

  init() {
    this.defineEvents()

    this.harms = new HeaderHarms(this.elements, this.config, this.classes)
  }
}

class HeaderMenu {
  constructor(elements, config, classes) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.states = {
      opened: false
    }

    this.init()
  }

  scroll = {
    disable(el) {
      disableBodyScroll(el)
    },
    enable() {
      clearAllBodyScrollLocks()
    }
  }

  isOpened() {
    return this.states.opened
  }

  defineCssVars() {
    this.elements.main.header.style.setProperty('--nav-animation-duration', `${this.config.animationDuration}ms`)
  }

  addOpenClasses() {
    this.elements.main.header.classList.add(this.classes.status.opened)
    this.elements.menu.nav.classList.add(this.classes.status.opened)
    this.elements.menu.toggleBtn.classList.add(this.classes.status.opened)
  }

  removeOpenClasses() {
    this.elements.main.header.classList.remove(this.classes.status.opened)
    this.elements.menu.nav.classList.remove(this.classes.status.opened)
    this.elements.menu.toggleBtn.classList.remove(this.classes.status.opened)
  }

  open() {
    this.addOpenClasses()

    this.scroll.disable(this.elements.menu.inner)

    this.elements.menu.inner.scrollTo(0, 0)

    this.states.opened = true
  }

  close(isForce) {
    const animateClosing = () => {
      this.elements.menu.nav.classList.add(this.classes.status.closing)
      setTimeout(() => {
        this.elements.menu.nav.classList.remove(this.classes.status.closing)
      }, this.config.animationDuration)
    }

    this.removeOpenClasses()

		this.removeItemOverview()

    if (!isForce || (typeof (isForce) === 'object')) {
      animateClosing()
    }

    this.scroll.enable()

    this.states.opened = false

    this.subMenu.forceClose()
  }

  toggleMenu() {
    if (this.isOpened()) {
			this.close()
			this.removeItemOverview()
    } else {
      this.open()
    }
	}

	removeItemOverview() {
		const newItem = document.querySelector(`.${this.classes.itemOverview}`)
		if (newItem) {
			newItem.remove()
		}
	}

  forceClose() {
    if (this.isOpened()) {
      const isForce = true

      this.close(isForce)
    }

    this.elements.main.header.classList.add(this.classes.status.transitionsOff)
    setTimeout(() => {
      this.elements.main.header.classList.remove(this.classes.status.transitionsOff)
    }, this.config.animationDuration)
  }

  defineEvents() {
    this.elements.menu.toggleBtn.addEventListener('click', this.toggleMenu.bind(this))
    this.elements.menu.overlay.addEventListener('click', this.close.bind(this))

    const media = `(min-width: ${this.config.breakpoint}px)`
    const mediaWatcher = window.matchMedia(media)
    mediaWatcher.addEventListener('change', this.forceClose.bind(this))
  }

  init() {
    this.defineCssVars()
    this.defineEvents()

    this.subMenu = new HeaderSubs(this.elements, this.config, this.classes, {
      scroll: this.scroll
    })
  }
}

class Header {
  constructor(elements, config, classes) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.init()
  }

  stickyToggle() {
    const height = this.elements.main.header.offsetHeight
    const isHeight = window.scrollY > height

    if (isHeight) {
      this.elements.main.header.classList.add(this.classes.status.sticky)
    } else {
      this.elements.main.header.classList.remove(this.classes.status.sticky)
    }
  }

  defineStickyEvent() {
    this.stickyToggle()
    window.addEventListener('scroll', this.stickyToggle.bind(this))
  }

  defineEvents() {
    this.defineStickyEvent()
  }

  defineMenu() {
    new HeaderMenu(this.elements, this.config, this.classes)
  }

  init() {
    this.defineEvents()
    this.defineMenu()
  }
}

const headerEl = document.querySelector('.header')

if (headerEl) {
  const navEl = headerEl.querySelector('.nav')

  new Header({
    main: {
      header: headerEl
    },
    menu: {
      toggleBtn: headerEl.querySelector('.header-burger'),
      overlay: headerEl.querySelector('.nav__overlay '),
      inner: navEl.querySelector('.nav__list'),
      nav: navEl,
    },
    sub: {
      openBtns: navEl.querySelectorAll('.has-sub-menu > a'),
      openedWrap: navEl.querySelector('.nav__dropdown-opener'),
      openedDest: navEl.querySelector('.nav__dropdown-destination'),
      backBtn: navEl.querySelector('.nav__dropdown-back')
    },
    harms: {
      items: navEl.querySelectorAll('.nav-dropdown__item_with-harm'),
    }
  }, {
    breakpoint: 1280,
    animationDuration: 500
  }, {
    elements: {
      dropItem: 'has-sub-menu',
      dropList: 'has-sub-menu > .sub-menu',
      harmLink: 'nav-dropdown__item_with-harm > a',
      harmItem: 'nav-dropdown__item_with-harm',
			harmList: 'nav-dropdown__item_with-harm > .sub-menu',
			itemOverview: 'js-item-overview'
    },
    status: {
      sticky: 'sticky',
      opened: 'opened',
      subOpened: 'sub-opened',
      closing: 'closing',
      transitionsOff: 'transitions-off'
    }
  })
}


// move bages
const mediaQuery = window.matchMedia('(max-width: 768px)')
const hero = document.querySelector('.hero')
const heroContainer = document.querySelector('.hero__container')

if (hero) {
	const heroBadges = hero.querySelector('.hero-badges')

	if (heroBadges) {
		function handleTabletChange(e) {
			if (e.matches) {
				hero.insertAdjacentElement('afterend', heroBadges)
			} else {
				heroContainer.appendChild(heroBadges)
			}
		}
		handleTabletChange(mediaQuery)

		mediaQuery.addEventListener('change', handleTabletChange)
	}
}


// old search popup
const btnSeach = document.querySelector('#search-icon')

if (btnSeach) {
	const popup = document.querySelector('.search-popup')
	const btnCloseSearch = document.querySelector('#close-icon')

	const hvrTop = document.querySelector('#search-hvr-top')
	const hvrBottom = document.querySelector('#search-hvr-bottom')
	const formField = document.querySelector('#form-field')

	function popupOpen() {
		popup.classList.add('active')
		document.body.style.height = '100%'
		document.body.style.overflow = 'hidden'

		hvrTop.classList.add('active')
		hvrBottom.classList.add('active')
		formField.classList.add('active')
	}

	function popupClose() {
		popup.classList.remove('active')
		document.body.style.height = ''
		document.body.style.overflow = ''

		hvrTop.classList.remove('active')
		hvrBottom.classList.remove('active')
		formField.classList.remove('active')
	}

	btnSeach.addEventListener('click', popupOpen)
	btnCloseSearch.addEventListener('click', popupClose)
	hvrTop.addEventListener('click', popupClose)
	hvrBottom.addEventListener('click', popupClose)
}
